import { Trash } from "lucide-react";

import { formatUnitMeasure } from "@/services/Utils";

import CustomButton from "@/components/desktop/button/CustomButton";
import ProductInput from "@/components/Form/Inputs/Product/ProductInput";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect.jsx";
import CustomSuggestionsDropdown from "@/components/desktop/products/product_suggestions/CustomSuggestionsDropdown";

import classes from "@/pages/Maintainers/maintainers.module.scss";

const formatProductOptionLabel = (data, { context }) => {
	if (context === "menu") {
		return null;
	}

	return <div>{data.label}</div>;
};

const ProductBulkManualForm = ({ items, products, unitMeasureOptions, onUpdateProduct, onApplySuggestion, onDeleteProduct, onAddProduct, setProducts }) => {
	const normalizeSuggestions = (suggestions = []) => {
		const mapUnitMeasurementLabel = {
			g: "Kg",
			kg: "Kg",
			gr: "Kg",
			gramo: "Kg",
			gramos: "Kg",
			cc: "L",
			ml: "L",
			l: "L",
			lt: "L",
			lts: "L",
			u: "Un",
			un: "Un",
			und: "Un",
			unidad: "Un",
			unidades: "Un",
		};

		return suggestions.map((suggestion) => ({
			...suggestion,
			unit_measurement_label:
				mapUnitMeasurementLabel[
					String(suggestion.unit_measurement || "")
						.trim()
						.toLowerCase()
				] || formatUnitMeasure(String(suggestion.unit_measurement || "").trim()),
		}));
	};

	return (
		<div className={classes.modal_child}>
			<div className={classes.bulk_preview_table_wrap}>
				<table className={classes.bulk_preview_table}>
					<thead>
						<tr>
							<th>#</th>
							<th>Producto</th>
							<th>Unidad</th>
							<th>Estado</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{items.map((input, index) => (
							<tr key={input.id}>
								<td className={classes.bulk_preview_index}>{index + 1}</td>
								<td>
									<div className={classes.bulk_preview_product_input_wrap}>
										<div className={classes.bulk_preview_product_input_main}>
											<CustomInputSelect
												value={input.value}
												options={products}
												async={true}
												components={{ Option: ProductInput }}
												creatable={true}
												formatCreateLabel={(value) => `Crear ${value}`}
												formatOptionLabel={formatProductOptionLabel}
												placeholder="Seleccione un producto"
												onChange={(value) => {
													const selectedProduct = products.find((productOption) => productOption.value === value);
													if (selectedProduct) {
														onUpdateProduct(input.id, "value", selectedProduct.value);
														onUpdateProduct(input.id, "label", selectedProduct.label);
														onUpdateProduct(input.id, "text_product", selectedProduct.label);
														onUpdateProduct(input.id, "unit", selectedProduct.unit_measurement);
														onUpdateProduct(input.id, "unit_measurement", selectedProduct.unit_measurement);
														onUpdateProduct(input.id, "is_new", false);
													}
												}}
												onCreateOption={(inputValue) => {
													setProducts([...products, { value: inputValue, label: inputValue }]);
													onUpdateProduct(input.id, "value", inputValue);
													onUpdateProduct(input.id, "label", inputValue);
													onUpdateProduct(input.id, "text_product", inputValue);
													onUpdateProduct(input.id, "is_new", true);
												}}
											/>
										</div>
										{input.is_new && (input.suggestions || []).length > 0 && (
											<CustomSuggestionsDropdown
												title="Productos sugeridos"
												suggestions={normalizeSuggestions(input.suggestions)}
												emptyText="No hay sugerencias"
												noUnitText="Sin unidad"
												onSelect={(selectedSuggestion) => onApplySuggestion(input.id, selectedSuggestion)}
											/>
										)}
									</div>
								</td>
								<td>
									{input.is_new ? (
										<CustomInputSelect
											options={unitMeasureOptions}
											onChange={(value) => onUpdateProduct(input.id, "unit_measurement", value)}
											value={input.unit_measurement}
											placeholder="Unidad"
											isClearable={false}
											creatable={false}
										/>
									) : (
										<span className={classes.bulk_preview_unit_text}>{formatUnitMeasure(input.unit_measurement || input.unit)}</span>
									)}
								</td>
								<td>
									<span className={input.is_new ? classes.bulk_preview_status_new : classes.bulk_preview_status_existing}>
										{input.is_new ? "Nuevo" : "Existente"}
									</span>
								</td>
								<td className={classes.bulk_preview_actions}>
									<button
										type="button"
										className={classes.bulk_preview_delete}
										disabled={items.length <= 1}
										onClick={() => onDeleteProduct(input.id)}
									>
										<Trash size={14} />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={classes.button_add}>
				<CustomButton variant="primary" size="md" onClick={onAddProduct}>
					Agregar Producto
				</CustomButton>
			</div>
		</div>
	);
};

export default ProductBulkManualForm;
